import { ApiServerEntityIDType } from '@common/types';
import React from 'react';
import { useClientOwnCatalogItemResponses } from './useClientOwnCatalogItemResponses';

export const useCatalogItemIsResponded = (catalogItemId: ApiServerEntityIDType): boolean => {
  const ownResponses = useClientOwnCatalogItemResponses();

  return React.useMemo(() => ownResponses.some((r) => r.catalogItemId === catalogItemId), [catalogItemId, ownResponses]);
};
